<template>
	<div class="purchase-page">
		<Loader :show="loading" />

		<div class="remainingTimer" v-if="remainingTime > 0" :class="{ warning: remainingTime <= 60 }">
			<i class="icon icon-clock"></i>{{ remainingTimeFormatted }}
			<span>Apurate! Tu reserva está a punto de caducar</span>
		</div>

		<div class="head-page">
			<div>
				<div class="btn " @click="$router.go(-1)">
					<i class="icon icon-left-open-big"></i>
				</div>
			</div>
		</div>

		<div v-if="order && !loading" class="content">
			<FormulateForm name="form" v-model="form" style="max-width:100%" @submit="purchase">
				<div class="card">
					<div class="card-body pb-4 mb-5">
						<EventData :eventId="order.event.id" />
					</div>
				</div>

				<div v-if="form.tickets.length > 0">
					<FormulateInput type="group" name="tickets" #default="{ index }" minimum="0">
						<div class="card">
							<div class="card-body">
								<div class="d-flex mb-3">
									<h5>
										Entrada {{ index + 1 }} -
										<small v-if="form.tickets[index] && form.tickets[index].ticketType"
											>{{ form.tickets[index].ticketType.ticketGroup.name }} -
											{{ form.tickets[index].ticketType.name }}</small
										>
									</h5>
								</div>

								<div class="row row-xs mb-3">
									<div class="col-12 col-md-3">
										<FormulateInput
											label="Nombre y apellido"
											name="name"
											validation-name="Nombre"
											validation="required"
										/>
									</div>
									<div class="col-12 col-md-4">
										<FormulateInput
											label="Documento de identidad"
											type="identification"
											name="document"
											validation-name="Documento de identidad"
											validation="bail|required|documentID"
										/>
									</div>
									<div class="col-12 col-md-5">
										<FormulateInput
											label="Correo electrónico"
											type="email"
											name="email"
											validation-name="Email"
											validation="bail|required|email"
										/>
									</div>
								</div>
							</div>
						</div>
					</FormulateInput>
				</div>

				<div class="card" v-if="!$store.getters.isAuthenticated && !user">
					<div class="card-body">
						<h4 class="mb-0">Mis datos</h4>
						<p class="mb-3">
							¿Ya tienes cuenta en CobraTicket?

							<router-link tag="a" :to="`/login?redirectTo=${$route.path}`" class="text-primary"
								>Inicia sesión</router-link
							>
						</p>

						<FormulateInput type="group" name="user">
							<div class="row row-xs mb-3">
								<div class="col-12 col-md-6">
									<FormulateInput
										label="Nombre"
										name="name"
										validation-name="Nombre"
										validation="required"
									/>
								</div>
								<div class="col-12 col-md-6">
									<FormulateInput
										label="Apellido"
										name="lastname"
										validation-name="Apellido"
										validation="required"
									/>
								</div>
							</div>
							<div class="row row-xs mb-3">
								<div class="col-12 col-md-6">
									<FormulateInput
										label="Documento de identidad"
										type="identification"
										name="document"
										validation-name="Documento de identidad"
										validation="bail|required|documentID"
									/>
								</div>

								<div class="col-12 col-md-6">
									<FormulateInput
										label="Teléfono"
										type="phone"
										name="phone"
										validation-name="Teléfono"
										validation="optional|^phone"
									/>
								</div>
							</div>
							<div class="row row-xs mb-3">
								<div class="col-12 col-md-6">
									<FormulateInput
										label="Correo electrónico"
										type="email"
										name="email"
										validation-name="Email"
										validation="bail|required|email"
									/>
								</div>
								<div class="col-12 col-md-6">
									<FormulateInput
										label="Confirmar correo electrónico"
										type="email"
										name="email_confirm"
										validation-name="Confirmar email"
										validation="bail|required|email|confirm"
									/>
								</div>
							</div>
						</FormulateInput>
					</div>
				</div>

				<div class="card ">
					<div class="card-body">
						<h4 class="mb-3">Resumen del pedido</h4>

						<div class="p-4 cart">
							<div class="cart-item" v-for="ticket in groupedTickets" :key="ticket.id">
								<p>
									{{ ticket.quantity }} x {{ ticket.ticketType.name }}<br />
									{{ ticket.ticketType.ticketGroup.name }}
								</p>
								<div>$ {{ ticket.price }}</div>
							</div>
							<div class="cart-item">
								<p>Cargo por servicio</p>
								<div>$ {{ order.commission }}</div>
							</div>
							<div class="cart-total">
								<span>Total</span>
								<span>$ {{ order.total }}</span>
							</div>
						</div>

						<div class="alert">
							Al hacer clic en "Finalizar compra", acepto los términos de servicio y he leído la política
							de privacidad. Acepto que CobraTicket pueda compartir mi información con el organizador del
							evento.
						</div>

						<div class="foot">
							<div class="btn btn-lg btn-primary btn-block" @click="$formulate.submit('form')">
								<span v-if="saving">Finalizando compra <span class="btn-loader" /> </span>
								<span v-else>Finalizar compra y pagar</span>
							</div>
						</div>
					</div>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Loader from "@/components/Loader"
import EventData from "@/views/events/EventData"

export default {
	name: "TicketPurchase",
	components: {
		Loader,
		EventData
	},
	data() {
		return {
			loading: true,
			saving: false,
			order: null,
			user: null,
			form: {
				user: [
					{
						name: "",
						lastname: "",
						document: { number: null, type: "UY" },
						email: "",
						phone: {
							countryCode: "UY"
						}
					}
				],
				tickets: []
			},
			interval: null,
			remainingTimeFormatted: null,
			now: this.$moment().format("YYYY-MM-DD HH:mm:ss")
		}
	},

	async beforeMount() {
		this.loading = true
		console.log(this.$route)
		if (!this.$route.params.orderId) {
			this.$router.go(-1)
			return null
		}
		await this.loadOrder()

		if (this.$store.getters.isAuthenticated) {
			this.user = this.$store.getters.loggedUser
		}
	},

	watch: {
		remainingTime: function(val) {
			if (val < 0) {
				clearInterval(this.interval)

				this.$dialog.alert({
					title: "Lo sentimos",
					body:
						"Han pasado más de 10 minutos sin que finalices tu compra, por lo que hemos liberado las entradas para que otros usuarios puedan tener acceso a ellas."
				})
				this.$router.go(-1)
			}
		}
	},
	computed: {
		groupedTickets: function() {
			// this.order.tickets
			var groupedTickets = []
			//goup tickets by ticketType and sum quantity
			this.order.tickets.forEach(function(ticket) {
				var found = groupedTickets.find(function(groupedTicket) {
					return groupedTicket.ticketType.id == ticket.ticketType.id
				})
				if (found) {
					found.quantity++
					found.price = found.price + found.ticketType.priceUnit
				} else {
					groupedTickets.push({
						ticketType: ticket.ticketType,
						quantity: 1,
						price: ticket.ticketType.priceUnit
					})
				}
			})
			return groupedTickets
		},
		remainingTime: function() {
			if (this.order && this.order.reservedAt) {
				var a = this.$moment(this.now).unix()
				var b = this.$moment(this.order.reservedAt).unix()
				var diff = b - a

				this.remainingTimeFormatted = this.$moment()
					.startOf("day")
					.seconds(diff)
					.format("mm:ss")

				return diff
			}
			return null
		}
	},
	methods: {
		startCountdown() {
			this.interval = setInterval(() => {
				this.now = this.$moment(this.now)
					.add(1, "second")
					.format("YYYY-MM-DD HH:mm:ss")
			}, 1000)
		},

		// cargo la orden
		loadOrder() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!, $reservedAtUpdate: Boolean) {
							order(id: $id, reservedAtUpdate: $reservedAtUpdate) {
								id
								event {
									id
									code
									name
									startAt
									image {
										id
										url
									}
								}
								tickets {
									id
									ticketType {
										id
										name
										priceUnit
										ticketGroup {
											id
											name
											holderRequired
										}
									}
									currency
									price
								}
								user {
									id
									name
									lastname
									phone {
										countryCode
										national
										international
										type
										validated
									}
									email
									document {
										type
										number
									}
								}
								reservedAt
								subtotal
								commission
								total
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.orderId,
						reservedAtUpdate: true
					}
				})
				.then(({ data }) => {
					if (data.order.status == "CANCELLED") {
						this.$router.push(`/e/${data.order.event.code}`)
						return null
					}

					this.order = this.$omitDeep(data.order, "__typename")
					// si la orden ya tiene usuario, lo cargo a form
					if (data.order.user) {
						this.form.user[0] = {
							name: data.order.user.name,
							lastname: data.order.user.lastname,
							document: data.order.user.document,
							email: data.order.user.email,
							phone: data.order.user.phone
						}
						console.log(this.form)
					}

					// cargo los tickets al form para que ingresen los holders
					this.form.tickets = []
					if (this.order.tickets) {
						this.order.tickets.forEach((ticket) => {
							if (ticket.ticketType.ticketGroup.holderRequired) {
								this.form.tickets.push({
									ticketId: ticket.id,
									ticketType: ticket.ticketType,
									name: "",
									document: { number: null, type: "UY" },
									email: "",
									phone: {
										countryCode: "UY"
									}
								})
							}
						})
					}

					this.startCountdown()
					this.loading = false
					return data.order
				})
		},

		// proceso para finalizar la compra
		async purchase() {
			console.log(" purchase")
			if (!this.saving) {
				this.saving = true

				// creo el usuario
				if (!this.$store.getters.isAuthenticated) {
					this.user = await this.userCreate()
					if (!this.user) {
						this.saving = false
						return
					}
				}

				// creo el pedido asignando el usuario a la orden y la confirmo.
				const order = await this.orderConfirm()
				if (!order) throw new Error("Error al confirmar la orden")

				const transaction = await this.transactionCreate()
				if (transaction) {
					// console.log(`transaction: ${transaction}`)

					// redirecciono a la pagina de pago
					if (transaction.paymentRedirectUrl) {
						window.location.href = transaction.paymentRedirectUrl
					}
				}
				this.saving = false
			}
		},

		// creo al usuario
		userCreate() {
			let data = {
				name: this.form.user[0].name,
				lastname: this.form.user[0].lastname,
				document: this.form.user[0].document,
				email: this.form.user[0].email,
				phone: this.form.user[0].phone
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: UserInput!) {
							userCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					return data.userCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		// confirmo la orden
		async orderConfirm() {
			let data = {
				userId: this.user.id,
				tickets: []
			}

			// agrego los tickets de la orden, y le cargo los holders del form.
			this.order.tickets.forEach((ticket) => {
				if (ticket.ticketType.ticketGroup.holderRequired) {
					const holder = this.form.tickets.find((holder) => holder.ticketId == ticket.id)
					data.tickets.push({
						id: ticket.id,
						holder: {
							name: holder.name,
							document: holder.document,
							email: holder.email,
							phone: holder.phone.validated ? holder.phone : null
						}
					})
				} else {
					data.tickets.push({
						id: ticket.id,
						holder: null
					})
				}
			})

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: OrderInput!) {
							orderConfirm(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.order.id,
						data
					}
				})
				.then(({ data }) => {
					return data.orderConfirm
				})
				.catch((error) => {
					this.parseGQLErrors(error)
				})
		},

		// creo la transaccion
		async transactionCreate() {
			console.log("transactionCreate")

			let data = {
				orderId: this.order.id
			}

			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: TransactionInput!) {
							transactionCreate(data: $data) {
								id
								paymentRedirectUrl
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(({ data }) => {
					console.log("transactionCreate return", data.transactionCreate)
					return data.transactionCreate
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.head-page {
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 700px;
	width: 100%;

	i {
		color: #fff;
		font-size: 20px;
	}
}

.card {
	width: 100%;
	border-radius: 4px;
	margin-bottom: 24px;
}

.purchase-page {
	position: relative;
	overflow: hidden;
	z-index: 0;
	min-height: 400px;
	background-color: #fff;

	display: flex;
	flex-direction: column;

	align-items: center;
	justify-content: center;

	&:before {
		display: block;
		content: "";
		position: absolute;
		top: 200px;
		left: 50%;
		transform: translateX(-50%);
		min-width: 2000px;
		width: 100%;
		z-index: -1;
		height: 200px;
		background: rgb(255, 198, 0);
		clip-path: polygon(0px 0px, 100% 0px, 100% 0px, 0px 100%);
	}
	&:after {
		display: block;
		content: "";
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		height: 201px;
		background: rgb(255, 198, 0);
		z-index: -1;
	}

	.content {
		max-width: 700px;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		border: none;

		position: relative;
		min-height: 600px;

		& /deep/ .event-data .image {
			width: 180px;
			height: 180px;
		}
	}
}

.cart {
	.label {
		font-weight: 500;
		color: #1e0a3c;
		font-size: 0.875rem;
		line-height: 1.25rem;
	}

	.cart-item {
		width: 100%;
		display: flex;
		justify-content: space-between;

		p {
			font-size: 0.95rem;
			font-weight: 500;
		}
	}

	.cart-total {
		border-top: 1px solid #eeedf2;
		padding: 16px 0px;
		font-weight: 500;
		font-size: 1.25rem;
		display: flex;
		justify-content: space-between;
	}
}

.remainingTimer {
	position: fixed;
	bottom: 12px;
	right: 12px;

	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 2;
	font-size: 1.1rem;
	color: rgb(168, 168, 168);
	font-weight: 500;
	border-radius: 22px;
	padding: 4px 12px;
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);

	.icon {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	span {
		display: none;
	}
	&.warning {
		background-color: #ffc107;
		color: #fff;
		span {
			display: inline-block;
			font-size: 0.9rem;
			margin-left: 8px;
		}
	}
}
.alert {
	color: #6f7287;
	background-color: #f8f7fa;
}
</style>
